import { DollarSign, Receipt } from 'lucide-react';
import { HubPageLayout, SettingsRowDef } from './HubPageLayout';

export function IomiBillingHubPage() {
  const rows: SettingsRowDef[] = [
    {
      id: 'pricing',
      label: 'Manage Pricing and Coupons',
      desc: 'View and manage Stripe products, prices, and coupons.',
      icon: DollarSign,
      path: '/admin/platform-tools/pricing',
    },
    {
      id: 'tax-settings',
      label: 'Tax Settings',
      desc: 'State taxability rules, interstate handling, and audit log.',
      icon: Receipt,
      path: '/admin/platform-tools/tax-settings',
    },
  ];

  return (
    <HubPageLayout
      title="Billing & Pricing"
      subtitle="Stripe products, prices, and coupons."
      rows={rows}
      backPath="/admin/platform-tools"
      backLabel="Platform Admin Tools"
    />
  );
}
